<template>
<!--底部-->
  <div class="footerWrap">
    <div class="mainWrap">
      <div class="footerLeft">
        <img class="logobot" src="../../assets/logo2.png"/>
        <p>地址：深圳市龙华区民治街道民乐社区星河WORLD二期C栋2501</p>
        <p>电话：0755-28288261</p>
        <p>©2018 勤博教育  <a href="https://beian.miit.gov.cn/" target="_blank" >粤ICP备18091277号-1</a>  前海勤博教育科技（深圳）有限公司 版权所有</p>
      </div>
      <div class="footerRight">
        <!--<div class="picitem">
          <img src="../../assets/app.png"/>
          <p>扫描下载APP</p>
        </div>-->
        <div class="picitem">
          <img src="../../assets/erweima1.png"/>
          <p>扫码关注订阅号</p>
        </div>
        <div class="picitem">
          <img src="../../assets/erweima2.jpg"/>
          <p>扫码关注服务号</p>
        </div>

      </div>
    </div>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .footerWrap{
    height: 220px;
    background-color: #282828;
    padding: 30px 0 ;
    margin-top: 50px;
    color: rgba(245,245,245,0.4);
    position: absolute;
    bottom: 0;
    width: 100%;
    .mainWrap{
      display: table;
      margin: auto;
      text-align: left;
      width: 1200px;
      .footerLeft{
        min-height: 120px;
        width: 100%;
        padding: 0 20px 0 130px;
        margin-top: 10px;
        position: relative;
        vertical-align: middle;
        .logobot{
          display: block;
          width: 110px;
          height: 50px;
          overflow: hidden;
          position: absolute;
          left: 0px;
           top: 4px;
        }
        p{
          font-size: 14px;
          line-height: 24px;
          margin-bottom: 10px;
        }
        a{
          color: rgba(245,245,245,0.4);
        }
      }
      .footerRight{
        display: table-cell;
        vertical-align: middle;
        text-align: right;
        width:350px;
        .picitem{
          display: inline-block;
          text-align: center;
          margin: 0 10px;
          img{
            display: inline-block;
            width: 134px;
            height: 134px;
            overflow: hidden;
          }
          p{
            font-size: 14px;
            margin: 15px 0 0 0;
          }
        }
      }
    }
  }
</style>
<script type="text/ecmascript-6">
    export default {
        name: '',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {}
    }
</script>
<script>
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?b2676d79313f803f17c3e808393a7b6c";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
</script>



// WEBPACK FOOTER //
// src/components/template/footer.vue